import getConfig from 'next/config';

export default function getAssetUrl(assetPath: string): string {
  const assetPrefix = getConfig().publicRuntimeConfig.assetPrefix;
  return `${assetPrefix || ''}${assetPath}`;
}
